/** Change quantity custom input */
jQuery(document).ready(function($) {
  const updateQuantity = (input, increment) => {
    const val = parseInt(input.val());
    const step = parseInt(input.attr("step")) || 1;
    const newVal = increment ? val + step : Math.max(val - step, step);
    
    input.val(newVal).change();
    $('input[name="update_cart"]').trigger("click");
  };

  $(document).on("click", ".quantity .quantity__plus, .quantity .quantity__minus", function() {
    const input = $(this).closest(".quantity").find("input.qty");
    updateQuantity(input, $(this).hasClass("quantity__plus"));
  });

  // Gestione del cambio prezzo per prodotti con variazioni
  const $priceOriginal = $(".price-original");
  const $priceSelected = $(".price-selected");

  $(document.body).on("found_variation", (e, variation) => {
    if (variation.price_html) {
      $priceOriginal.fadeOut(100, () => {
        $priceSelected.html(variation.price_html).fadeIn(100);
      });
    }
  }).on("reset_data", () => {
    $priceSelected.fadeOut(100, () => {
      $priceOriginal.fadeIn(100);
    });
  });

  // Gestione degli accordion del prodotto
  $(".product-accordions").on("click", ".accordion_lista__title", function() {
    const $content = $(this).closest(".accordion_lista__item");
    const className = "accordion_lista__item--open";

    $content.toggleClass(className)
      .find(".accordion_lista__content")
      .slideToggle();
  });

  // Gestione delle schede prodotto
  const $woocommerceTabs = $('.woocommerce-tabs');
  $woocommerceTabs.addClass('ui-accordion ui-widget ui-helper-reset')
    .children('h2')
    .addClass('ui-accordion-header ui-helper-reset ui-state-default ui-corner-top ui-corner-bottom')
    .next()
    .addClass('ui-accordion-content ui-helper-reset ui-widget-content ui-corner-bottom')
    .hide();

  $woocommerceTabs.on('click', '> h2', function(e) {
    e.preventDefault();
    $(this)
      .toggleClass('ui-accordion-header-active ui-state-active ui-state-default ui-corner-bottom')
      .toggleClass('ui-corner-top')
      .next()
      .toggleClass('ui-accordion-content-active')
      .slideToggle();
  });

  // Gestione del popup di packaging
  const $selectPackaging = $('.select-packaging.select-woo-ortica');
  const $popupPackaging = $('.popup-packaging');

  $selectPackaging.on('click', function(e) {
    e.preventDefault();
    $popupPackaging.toggleClass('popup-packaging--active');
  });

  $popupPackaging.on('click', function() {
    $(this).removeClass('popup-packaging--active');
  });

  // Gestione della freccia di scorrimento
  const $scrollArrow = $('.scroll-arrow');
  const $productHead = $('.product-head');
  
  $scrollArrow.on('click', function() {
    $('html, body').animate({
      scrollTop: $productHead.outerHeight()
    }, 800);
  });
  
  $(window).on('scroll', function() {
    $scrollArrow.toggleClass('scroll-arrow--hidden', $(this).scrollTop() > 100);
  });
});

// Creazione del wrapper per la select del peso
document.addEventListener("DOMContentLoaded", function() {
  const selectElement = document.getElementById('pa_peso');
  if (!selectElement) return;

  const wrapper = document.createElement('div');
  wrapper.className = 'select-woo-ortica';

  const iconBefore = document.createElement('div');
  iconBefore.className = 'select-ico';
  iconBefore.innerHTML = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M19 4.00019H17.55C17.4306 3.6355 17.244 3.29635 17 3.00019C16.717 2.68383 16.3702 2.43111 15.9823 2.25872C15.5945 2.08634 15.1744 1.99822 14.75 2.00019H9.27C8.8422 1.99538 8.41832 2.08212 8.02681 2.25459C7.63529 2.42706 7.28519 2.68128 7 3.00019C6.74885 3.29474 6.55547 3.634 6.43 4.00019H5C4.20435 4.00019 3.44129 4.31626 2.87868 4.87887C2.31607 5.44148 2 6.20454 2 7.00019V19.0002C2 19.7958 2.31607 20.5589 2.87868 21.1215C3.44129 21.6841 4.20435 22.0002 5 22.0002H19C19.7956 22.0002 20.5587 21.6841 21.1213 21.1215C21.6839 20.5589 22 19.7958 22 19.0002V7.00019C22 6.20454 21.6839 5.44148 21.1213 4.87887C20.5587 4.31626 19.7956 4.00019 19 4.00019ZM8.52 4.34019C8.61371 4.23352 8.72906 4.14803 8.85838 4.08941C8.9877 4.03078 9.12802 4.00037 9.27 4.00019H14.73C14.872 4.00037 15.0123 4.03078 15.1416 4.08941C15.2709 4.14803 15.3863 4.23352 15.48 4.34019C15.5744 4.44519 15.6454 4.56898 15.6885 4.70342C15.7316 4.83786 15.7457 4.9799 15.73 5.12019L15.23 9.12019C15.2005 9.3641 15.0823 9.58862 14.8979 9.75093C14.7134 9.91324 14.4757 10.002 14.23 10.0002H12.59L13.73 7.60019C13.8224 7.36484 13.8223 7.1032 13.7296 6.86796C13.6369 6.63272 13.4585 6.44133 13.2303 6.33232C13.0022 6.22332 12.7412 6.20479 12.4999 6.28047C12.2587 6.35614 12.055 6.52041 11.93 6.74019L10.37 10.0002H9.77C9.52432 10.002 9.28659 9.91324 9.10215 9.75093C8.91771 9.58862 8.79948 9.3641 8.77 9.12019L8.27 5.12019C8.25425 4.9799 8.26839 4.83786 8.31148 4.70342C8.35457 4.56898 8.42563 4.44519 8.52 4.34019ZM20 19.0002C20 19.2654 19.8946 19.5198 19.7071 19.7073C19.5196 19.8948 19.2652 20.0002 19 20.0002H5C4.73478 20.0002 4.48043 19.8948 4.29289 19.7073C4.10536 19.5198 4 19.2654 4 19.0002V7.00019C4 6.73497 4.10536 6.48062 4.29289 6.29308C4.48043 6.10555 4.73478 6.00019 5 6.00019H6.37L6.79 9.37019C6.88069 10.1001 7.23638 10.7713 7.78946 11.2561C8.34255 11.741 9.05449 12.0058 9.79 12.0002H14.25C14.9855 12.0058 15.6975 11.741 16.2505 11.2561C16.8036 10.7713 17.1593 10.1001 17.25 9.37019L17.63 6.00019H19C19.2652 6.00019 19.5196 6.10555 19.7071 6.29308C19.8946 6.48062 20 6.73497 20 7.00019V19.0002ZM14 16.0002H10C9.73478 16.0002 9.48043 16.1055 9.29289 16.2931C9.10536 16.4806 9 16.735 9 17.0002C9 17.2654 9.10536 17.5198 9.29289 17.7073C9.48043 17.8948 9.73478 18.0002 10 18.0002H14C14.2652 18.0002 14.5196 17.8948 14.7071 17.7073C14.8946 17.5198 15 17.2654 15 17.0002C15 16.735 14.8946 16.4806 14.7071 16.2931C14.5196 16.1055 14.2652 16.0002 14 16.0002Z" fill="#101010"/>
</svg>`;

  const iconAfter = document.createElement('div');
  iconAfter.className = 'select-arrow';
  iconAfter.innerHTML = `<svg width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M13.4577 6.51953L8.49935 11.4779L3.54102 6.51953" stroke="#200E32" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;

  selectElement.parentNode.insertBefore(wrapper, selectElement);
  wrapper.append(selectElement, iconBefore, iconAfter);
});

// Spostamento del div select-packaging
document.addEventListener("DOMContentLoaded", function() {
  const variationsTable = document.querySelector('table.variations');
  const selectPackagingDiv = document.querySelector('div.select-packaging');

  if (variationsTable && selectPackagingDiv) {
    const targetRow = variationsTable.querySelector('tbody > tr');
    if (targetRow) {
      const newRow = document.createElement('tr');
      newRow.appendChild(selectPackagingDiv);
      targetRow.parentNode.insertBefore(newRow, targetRow);
    }
  }
});